__turbopack_context__.v({
  "background_image": "styles-module-scss-module__1EJbLq__background_image",
  "bottom": "styles-module-scss-module__1EJbLq__bottom",
  "content_area": "styles-module-scss-module__1EJbLq__content_area",
  "description_container": "styles-module-scss-module__1EJbLq__description_container",
  "footer": "styles-module-scss-module__1EJbLq__footer",
  "footer_wrap": "styles-module-scss-module__1EJbLq__footer_wrap",
  "leadingre_partner_links": "styles-module-scss-module__1EJbLq__leadingre_partner_links",
  "leadingre_partner_links_container": "styles-module-scss-module__1EJbLq__leadingre_partner_links_container",
  "legal_links": "styles-module-scss-module__1EJbLq__legal_links",
  "link_container": "styles-module-scss-module__1EJbLq__link_container",
  "logo_class": "styles-module-scss-module__1EJbLq__logo_class",
  "logo_container": "styles-module-scss-module__1EJbLq__logo_container",
  "menu_links": "styles-module-scss-module__1EJbLq__menu_links",
  "partner_badges": "styles-module-scss-module__1EJbLq__partner_badges",
  "partner_links": "styles-module-scss-module__1EJbLq__partner_links",
  "partner_links_group": "styles-module-scss-module__1EJbLq__partner_links_group",
  "partner_links_set_two": "styles-module-scss-module__1EJbLq__partner_links_set_two",
  "partners_container": "styles-module-scss-module__1EJbLq__partners_container",
  "social_nav_desktop": "styles-module-scss-module__1EJbLq__social_nav_desktop",
  "social_nav_mobile": "styles-module-scss-module__1EJbLq__social_nav_mobile",
  "top": "styles-module-scss-module__1EJbLq__top",
});
